import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface FinancialScores {
  symbol: string;
  reportedCurrency: string;
  altmanZScore: number;
  piotroskiScore: number;
  workingCapital: number;
  totalAssets: number;
  retainedEarnings: number;
  ebit: number;
  marketCap: number;
  totalLiabilities: number;
  revenue: number;
}

export function useCompanyFinancialScores(ticker: string) {
  return useQuery<FinancialScores[], Error>({
    queryKey: ["companyFinancialScores", ticker],
    queryFn: async () => {
      const { data } = await api.get<FinancialScores[]>("/company-financial-scores", {
        params: { ticker },
      });
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 2.5 * 60 * 1000, // 2.5 minutes for fresh data
    retry: (failureCount, error) => {
      // Don't retry on 404s - legitimately means no financial scores data exists
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any)?.response?.status === 404) {
        return false;
      }
      // Retry other errors (500s, network issues) max 2 times
      return failureCount < 2;
    },
  });
}